var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"film-app"}},[_c('div',{staticClass:"top"},[_c('div'),_c('p',[_c('i',{staticClass:"iconfont",on:{"click":_vm.small}},[_vm._v("")]),_c('i',{staticClass:"iconfont",on:{"click":_vm.max}},[_vm._v("")]),_c('i',{staticClass:"iconfont",on:{"click":_vm.close}},[_vm._v("")])])]),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }